import GallerySectionConfig from '../Configuration/GallerySectionConfig';
import GalleryBanner from './GalleryBanner';
import Gallery from '@structure/Resources/Gallery';
import GalleryBannerConfig from '@structure/Configuration/GalleryBannerConfig';

export default class GallerySection {
  constructor(
    protected configuration: GallerySectionConfig,
    protected gallery: Gallery
  ) {
    //
  }

  public config(): GallerySectionConfig {
    return this.configuration;
  }

  public name(): string {
    return this.config().name();
  }

  public shouldStack(): boolean {
    return this.config().stack();
  }

  public banners(): GalleryBanner[] {
    return this.config()
      .banners()
      .map((config: GalleryBannerConfig) => {
        const banner = this.gallery
          .banners()
          .find(b => config.basename() === b.basename());

        return new GalleryBanner(config, banner);
      });
  }
}
